import { ElaborationStatusItem } from "../redux/feature/object/remote-elaborations-slice";
import NotificationManager from "../common/notification/NotificationManager";
import { EXPORT_OBJECTS_LIST_NOTIFICATION } from "../utils/constants/notification";
import { formatMessage } from "../utils/helpers/LanguageHelper";
import { saveAs } from "file-saver";

export async function handleExportObjectsListResult(item: ElaborationStatusItem) {
  if (item.status === "COMPLETED" && item.elabResult) {
    try {
      const blob = base64ToBlob(item.elabResult, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
      saveAs(blob, "Intelligent Disclosure - Object export.xlsx");
      return;
    } catch (error) {
      console.error("Base64 decode error", error);
    }
  }

  // Error case
  NotificationManager.addNotification({
    key: EXPORT_OBJECTS_LIST_NOTIFICATION,
    message: formatMessage("cof.exportobjects.message.error.noobjects"),
    title: formatMessage("cof.exportobjects.title.error.noobjects"),
    type: "error",
    closable: true,
    removeOnClose: true,
    isTemporary: true,
  });

  console.error("Error Saving File", item.messages);
}

function base64ToBlob(base64: string, contentType: string): Blob {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);

  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return new Blob([bytes], { type: contentType });
}
